import React, { Component } from 'react';
import { UnauthorizedMessage } from 'ui/components';

import './AccessDenied.scss';

export default class AccessDenied extends Component {
	render() {
		return (
			<div className="AccessDenied">
				<UnauthorizedMessage />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/AccessDenied/index.js